export const BRAND = {
  name: "Sterio Renewables",
  tagline: "Sustainable Heating Solutions",
  website: "www.steriorenewables.ie",
  cro: "739812",
  vat: "7670964R",
  address: "1 Wheatfields Park, Clondalkin, D22 KF29",
  phone: "085 170 2947",
  email: "Info@steriorenewables.ie",
  green: "#1B6B4C",
  greenDark: "#145239",
  black: "#111827",
  logoFull:
    "https://customer-assets.emergentagent.com/job_fieldpump-pro/artifacts/nlxiyp0h_images%20%284%29.jpeg",
  logoMark:
    "https://customer-assets.emergentagent.com/job_fieldpump-pro/artifacts/xop75p1k_cropped-fb-Social-Profile-Graphic-4.png",
};
